// frontend/src/App.js - Fixed with AdminApp integration
import { Routes, Route, useLocation } from 'react-router-dom';
import CustomerBooking from './components/CustomerBooking';
import AdminApp from './AdminApp';
import './App.css';

// Navigation component - Clean public navigation
const Navigation = () => {
  const location = useLocation();

  // Hide navigation on admin pages (admin has its own nav)
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return null; // Public booking page has its own header
};

// Main App component
function App() {
  return (
    <div className="App">
      <Navigation />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<CustomerBooking />} />
          <Route path="/debug" element={<div>Debug Page</div>} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;